import { prepareBookingsForRedux } from 'utils/prepare-bookings'
import HelperObject from "utils/helper-object";
import Translate from "utils/translate";
import _ from "lodash";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import { bookingConstants, bookingKindList, bookingStatusActive, bookingStatusActiveCount } from "utils/constants/booking-constants";
import ObjectClass from "utils/objects/object";
import { colorList } from "utils/colors";
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";
import ObjectTimeslot from 'utils/objects/timeslot'
import HelperString from 'utils/helper-string'
import selectBookings from 'services/redux/data/selectors/selectBookings'
import { constantsActive } from 'utils/constants/constants'
import HelperDate, { dateFormat } from 'utils/helper-date'
import { combineKindSubKind } from 'utils/timeslot-key'

export default class ObjectBooking {
	
	/**
	 *
	 * @param value
	 */
	static log = ( value ) => {
		console.prefix( 'HelperBooking', value );
	}
	
	static key( booking ) {
		const objects = [
			booking.booking_date,
			_.get( booking, ['building', 'guid'], '?' ),
			_.get( booking, ['floor', 'guid'], '?' ),
			_.get( booking, ['room', 'guid'], '?' ),
		];
		
		return objects.join('|')
	}
	
	/**
	 *
	 * @param booking
	 * @param until
	 * @returns {*}
	 */
	static removeKeyUntil = ( booking, until ) => {
		const list = [ bookingConstants.ROOM, bookingConstants.FLOOR, bookingConstants.BUILDING ];
		let foundUntil = false;
		
		_.forEach( list, key => {
			if( !foundUntil ) {
				if( key !== until ) {
					booking[ key ] = {};
				} else {
					foundUntil = true;
				}
			}
		});
		
		return booking;
	}
	
	/**
	 *
	 * @param booking
	 */
	static timeslotStart = ( booking ) => {
		return HelperDate.date( booking.booking_date +" "+ booking.timeslot.timeslot_start );
	}
	
	/**
	 *
	 * @param booking
	 */
	static timeslotEnd = ( booking ) => {
		return HelperDate.date( booking.booking_date +" "+ booking.timeslot.timeslot_end );
	}
	
	/**
	 *
	 * @param booking
	 * @returns {[]|*[]}
	 */
	static getTimeSlot = ( booking ) => {
		// When only one kind available, and it is transport? Then do NOT show the timeslot
		
		const timeslots = [];
		_.forEach( ['timeslot_start', 'timeslot_end'], slot => {
			let timeslot = _.get( booking, ['timeslot', slot], null );
			
			if( _.isEmpty( timeslot ) ) {
				timeslot = _.get( booking, [slot], null );
			}
			
			if( !_.isEmpty( timeslot ) ) {
				timeslots.push( HelperDate.date( timeslot, dateFormat.FULL_TIME ).format( dateFormat.SHORT_TIME ) );
			}
		})
		
		return timeslots;
	}
	
	/**
	 * Get the color of the booking kind
	 * @param booking
	 * @returns {{primaryDark: string, primary: string}}
	 */
	static getColor = ( booking ) => {
		switch( booking.kind ) {
			case bookingConstants.BOOKING:
				return colorList.ORANGE;
				
			case bookingConstants.MEETING_ROOM:
				return colorList.PURPLE;
			
			case bookingConstants.TRANSPORT:
				return colorList.GREEN;
			
			case bookingConstants.LUNCH:
				return colorList.BLUE;
			
			default:
				return colorList.GREY;
		}
	}
	
	/**
	 * Remove inactive bookings
	 * @param bookings
	 * @returns {[]}
	 */
	static filter = ( bookings ) => {
		const filtered = [];
		
		_.forEach( this.filterEmptyEmployees( bookings ), booking => {
			if( ObjectClass.isActive( booking ) ) {
				filtered.push( booking );
			}
		})
		
		return filtered;
	}
	
	static filterEmptyEmployees = ( bookings ) => {
		return _.filter( bookings, booking => {
			const employee = _.get( booking, 'employee', {} );
			
			return !_.isEmpty( employee )
		})
	}
	
	/**
	 *
	 * @param booking
	 * @returns {boolean}
	 */
	static isAccepted = ( booking ) => {
		return _.includes( bookingStatusActive, _.get( booking, 'status', '' ) );
	}
	
	/**
	 *
	 * @param booking
	 * @returns {boolean}
	 */
	static isInvitedOrAccepted = ( booking ) => {
		return _.includes( bookingStatusActiveCount, _.get( booking, 'status', '' ) );
	}
	
	/**
	 * Sort the bookings by start
	 * @param bookings
	 * @returns {unknown[]}
	 */
	static order = ( bookings ) => {
		return _.sortBy( _.orderBy( bookings, 'timeslot.timeslot_start', 'asc' ), o => {
			return _.indexOf( bookingKindList, _.get( o, 'kind', bookingConstants.BOOKING ) );
		} );
	}
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param bookings
	 * @returns {unknown[]}
	 */
	static filterAndOrder = ( bookings ) => {
		return this.order( this.filter( bookings ) );
	}
	
	/**
	 *
	 * @param bookings
	 * @param status
	 * @returns {unknown[]}
	 */
	static filterByStatus = ( bookings, status = [] ) => {
		return _.filter( ObjectBooking.filterAndOrder( bookings ), o => {
			return _.includes( status, o.status )
		});
	}
	
	/**
	 *
	 * @param bookings
	 * @returns {unknown[]}
	 */
	static filterAccepted = ( bookings ) => {
		return _.filter( ObjectBooking.filterAndOrder( bookings ), o => {
			return this.isAccepted( o );
		});
	}
	
	/**
	 * Prepare the bookings for storing in redux
	 * We add data to the booking for later use
	 * @param bookings
	 * @returns {{}}
	 */
	static prepareForRedux = prepareBookingsForRedux;

	/**
	 *
	 * @param bookings
	 * @param date
	 */
	static filterByDate = ( bookings, date = HelperDate.date() ) => {
		return _.filter( ObjectBooking.filterAndOrder( bookings ), o => {
			return o.booking_date === date.format( dateFormat.DATE )
		});
	}
	
	/**
	 *
	 * @param bookings
	 * @param maxDots
	 * @param oneOfAKind
	 * @returns {[]}
	 */
	static getDots = ( bookings, { maxDots = 5, oneOfAKind = false } = {} ) => {
		// Sort the bookings by date
		const dots = {};
		_.forEach( this.filterAccepted( bookings ), booking => {
			const date = booking.dayjs.format( dateFormat.DATE );
			
			if( !_.has( dots, date ) ) {
				dots[ date ] = {
					dots: []
				};
			}
			
			if( _.size( dots[ date ].dots ) < maxDots ) {
				const identifier = `${booking.timeslot?.kind}_${booking.timeslot?.sub_kind}`;
				const timeslotKinds = store.getState().data[ dataConstants.TIMESLOT_KINDS ][ identifier ];
				
				let color = this.getColor( booking ).primary;
				
				if( timeslotKinds !== undefined ){
					color = timeslotKinds.background_color;
				}
				
				// If oneOfAKind only add one of each kin
				if( oneOfAKind && !_.isEmpty( _.find( dots[ date ].dots, { color: color } ) ) ) {
					return;
				}
				
				dots[ date ].dots.push( {
					color: color
				});
			}
		});
		
		return dots;
	}
	
	/**
	 *
	 * @param booking
	 * @param _buildings
	 * @param _floors
	 * @param _rooms
	 * @returns {{title: string, key: string}}
	 */
	static extractKeyTitle = ( booking, { _buildings = {}, _floors = {}, _rooms = {} } = {}) => {
		const key = [];
		const title = [];
		
		_.forEach( { 'building': _buildings, 'floor': _floors, 'room': _rooms }, ( objects, type ) => {
			const typeGuid = _.get( booking, [ type, 'guid' ], null );
			
			if( typeGuid !== null ) {
				const typeObject = _.get( objects, typeGuid, {} );
				
				key.push( typeGuid );
				title.push( Translate.field( typeObject, 'title') );
			}
		});
		
		return {
			key: key.join('-'),
			title: title.join(' - ')
		}
	}
	
	/**
	 *
	 * @param booking
	 * @returns {boolean}
	 */
	static isInvitation = ( booking ) => {
		return _.get( booking, ['booking_invitation', 'guid'], null ) !== null;
	}
	
	/**
	 *
	 * @param booking
	 * @returns {*}
	 */
	static getInvitation = booking => {
		const bookingInvitation = _.get( booking, ['booking_invitation'], {} );
		
		return !_.isEmpty( bookingInvitation ) ? bookingInvitation : null;
	}
	
	/**
	 *
	 * @param cartItems
	 * @returns {boolean}
	 */
	static didAlreadyBook = ( cartItems ) => {
		const _bookings = this.filterAccepted( selectBookings( store.getState() ) );
		
		// Get the dates
		const dates = _.map( cartItems, o => {
			return o.booking_date;
		} );
		
		// Filter lunch bookings by date
		const lunchBookings = _.filter( _bookings, o => {
			return o?.kind === bookingConstants.LUNCH && _.includes( dates, o?.booking_date )
		} );
		
		// Get all the cart lunch keys
		const bookingKeys = _.map( lunchBookings, o => {
			return FetchTimeslotCapacity.keyByBooking(o);
		} )
		
		// Check if the new 'booking' is not already booked
		const filteredLunchBookings = _.filter( cartItems, o => {
			return !_.includes( bookingKeys, FetchTimeslotCapacity.keyByBooking( o ) )
		})
		
		return _.size( filteredLunchBookings ) === 0;
	}

	static isCreditRequired = ( booking ) => {
		const _timeslotKinds = store.getState().data[ dataConstants.TIMESLOT_KINDS ]

		const identifier = combineKindSubKind( booking.timeslot );
		const timeslotKind = _timeslotKinds[ identifier ];

		// Get the amount of credits
		const creditAmount = timeslotKind?.credit_amount ?? 0;

		return {
			timeslot_kind: timeslotKind,

			// 
			credit_amount: creditAmount,
			required: creditAmount > 0,
		};
	}
	
	/**
	 * Return data from the object (booking, floor, room, table)
	 * @param object
	 */
	static data = ( object ) => {
		const items = [
			{
				storeKey: dataConstants.BUILDINGS,
				collectionKey: 'building'
			},
			{
				storeKey: dataConstants.FLOORS,
				collectionKey: 'floor'
			},
			{
				storeKey: dataConstants.ROOMS,
				collectionKey: 'room'
			},
			{
				storeKey: dataConstants.TABLES,
				collectionKey: 'table'
			}
		]
		
		// Get data
		const storeData = store.getState().data;
		
		let result = {};
		_.forEach( items, item => {
			const objectItemGuid = _.get( object, [ item.collectionKey, 'guid'], null );
			
			result[ item.collectionKey ] = objectItemGuid !== null ? _.get( storeData[ item.storeKey ], objectItemGuid, null ) : null
		})
		
		return result;
	}
	
	/**
	 *
	 * @param bookings
	 * @param hideNotScannedIn
	 * @param showInvitationsOnly
	 * @param appendKey
	 * @param showEroOnly
	 */
	static group = ( bookings, { hideNotScannedIn = false, showInvitationsOnly = false, appendKey = 0, showEroOnly = false } = {} ) => {
		let list = {};
		
		// Always sort the bookings
		bookings = _.orderBy( bookings, 'timeslot.timeslot_start' );
		
		// Remove the bookings which are not required
		let filteredBookings = [];
		_.forEach( this.filterEmptyEmployees( bookings ), ( booking ) => {
			const isInvitation = this.isInvitation( booking );
			
			// When hide is active and employeeScan is empty
			// Then return nothing for this loop
			if( hideNotScannedIn ) {
				if( !_.isEmpty( _.get( booking, 'employee_scan', {} ) ) ) {
					return;
				}
			}
			
			// When only show invitations
			// Skip the booking when not a invitation
			if( showInvitationsOnly ) {
				if( !isInvitation ) {
					return;
				}
			}
			
			// When only show ERO
			if( showEroOnly ) {
				if( _.get( booking, ['employee', 'response_employee'], constantsActive.NO ) !== constantsActive.YES ) {
					return;
				}
			}
			
			filteredBookings.push( booking )
		});
		
		let missedBookings = {};
		_.forEach( filteredBookings, ( booking ) => {
			const timeslot = _.get( booking, 'timeslot' );
			
			const isInvitation = this.isInvitation( booking );
			
			// Create a unique key
			const key = this.key( booking );
			const subKey = _.get( booking, [ isInvitation ? 'booking_invitation' : 'employee', 'guid'], '?' ) +'|'+ appendKey;
			const bookingInvitation = this.getInvitation( booking );
			
			// Update the key counter
			if( !_.has( missedBookings, subKey ) ) {
				missedBookings[ subKey ] = [];
			}
			
			let shouldAddBooking = false;
			if( !_.has( list, key ) ) {
				list[ key ] = {};
			}
			
			if( !_.has( list[ key ], subKey ) ) {
				list[ key ][ subKey ] = {
					data: {
						...ObjectBooking.data( booking ),
						booking_date: booking.booking_date,
						kind: _.get( timeslot, ['kind'] ),
						startTime: HelperDate.date( timeslot.timeslot_start, dateFormat.FULL_TIME ),
						endTime: HelperDate.date( timeslot.timeslot_end, dateFormat.FULL_TIME ),
						bookingInvitation: bookingInvitation
					},
					timeslots: [],
					employees: {}
				};
				
				// Always add now
				shouldAddBooking = true;
			}
			
			// We should not yet add the booking? Do extra checks
			if( !shouldAddBooking ) {
				
				// Timeslot already added? Good.. then add the booking
				if( list[ key ][ subKey ].timeslots.includes( timeslot.guid ) ) {
					shouldAddBooking = true;
				} else {
					
					// Check the time
					const { isAfterOrBefore, newStartDate, newEndDate } = ObjectTimeslot.isAfterOrBefore(
						timeslot.timeslot_start,
						timeslot.timeslot_end,
						list[ key ][ subKey ].data.startTime,
						list[ key ][ subKey ].data.endTime
					)
					
					shouldAddBooking = isAfterOrBefore;
					if( shouldAddBooking ) {
						if( newStartDate !== null ) {
							list[ key ][ subKey ].data.startTime = newStartDate;
						}
						
						if( newEndDate !== null ) {
							list[ key ][ subKey ].data.endTime = newEndDate;
						}
					}
				}
			}
			
			// Add the booking
			if( shouldAddBooking ) {
			
				// Add the timeslot
				if( !list[ key ][ subKey ].timeslots.includes( timeslot.guid ) ) {
					list[ key ][ subKey ].timeslots.push( timeslot.guid )
				}
				
				const employeeGuid = _.get( booking, ['employee', 'guid'], HelperString.random() );
				if( !_.has( list[ key ][ subKey ].employees, employeeGuid ) ) {
					list[ key ][ subKey ].employees[ employeeGuid ] = {
						...booking.employee,
						bookings: []
					}
				}
				
				// Add booking to the employee
				list[ key ][ subKey ].employees[ employeeGuid ].bookings.push( booking );
			} else {
				
				// Add the missed bookings to the list
				missedBookings[ subKey ].push( booking )
			}
		});
		
		if( !_.isEmpty( missedBookings ) ) {
			_.forEach( missedBookings, missedBookingList => {
				const { list: extraBookingList, filteredBookings: extraFilteredBookings } = this.group( missedBookingList, {
					hideNotScannedIn,
					appendKey: ++appendKey,
					showEroOnly: showEroOnly
				} );
				
				if( !_.isEmpty( extraFilteredBookings ) ) {
					filteredBookings = [
						...filteredBookings,
						...extraFilteredBookings,
					]
				}
				
				_.forEach( extraBookingList, ( extraBooking, extraBookingKey ) => {
					list[ extraBookingKey ] = {
						...list[ extraBookingKey ],
						...extraBooking
					}
				})
			})
		}
		
		return {
			list,
			bookings: filteredBookings
		};
	}
}

export const getCurrentBooking = ( bookings ) => {
	const currentTime = HelperDate.date();
	let result = null;
	
	// Filter for today
	const bookingsToday = _.sortBy( ObjectBooking.filterByDate( bookings ), [ 'booking_date', 'timeslot.timeslot_start' ] );
	
	_.forEach( bookingsToday, booking => {
		if( booking?.kind !== bookingConstants.TRANSPORT ) {
			const timeslotStart = HelperDate.date( booking.timeslot.timeslot_start, dateFormat.FULL_TIME );
			const timeslotEnd = HelperDate.date( booking.timeslot.timeslot_end, dateFormat.FULL_TIME );
			
			if( currentTime.isBetween( timeslotStart, timeslotEnd ) ) {
				result = booking;
				
				// break out of the loop
				return false;
			}
		}
	})
	
	// Not found?
	// Try to find the first next one
	if( result === null ) {
		_.forEach( bookingsToday, booking => {
			if( booking?.kind !== bookingConstants.TRANSPORT ) {
				const timeslotStart = HelperDate.date( booking.timeslot.timeslot_start, dateFormat.FULL_TIME );
				
				if( currentTime.isBefore( timeslotStart ) ) {
					result = booking;
					
					// break out of the loop
					return false;
				}
			}
		})
	}
	
	// Not found?
	// Try to find the first last one
	if( result === null ) {
		_.forEach( _.reverse( bookingsToday ), booking => {
			if( booking?.kind !== bookingConstants.TRANSPORT ) {
				const timeslotStart = HelperDate.date( booking.timeslot.timeslot_start, dateFormat.FULL_TIME );
				if( currentTime.isAfter( timeslotStart ) ) {
					result = booking;
					
					// break out of the loop
					return false;
				}
			}
		})
	}
	
	return result;
}
